<div class="text-center">
    <img src="https://app.alax.tech/consumer/getDiscountQR?qr_code={{data.qrCode}}" width="300">
</div>